export const checkIsSupportCss = (element: HTMLElement) => {
  const elementStyle = getComputedStyle(element);
  return (
    elementStyle.webkitLineClamp !== undefined &&
    elementStyle.webkitBoxOrient !== undefined
  );
};
